// extracted by mini-css-extract-plugin
export var formContainer = "_c0-0";
export var message = "_c0-1";